var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"myfavors"},[_c('MatchList',{attrs:{"list":_vm.matchList},on:{"infiniteHandler":_vm.infiniteHandler}}),_c('infinite-loading',{on:{"infinite":_vm.infiniteHandler}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }